import { useI18n } from '../../../../../i18n';
import {
  fetchCategoriasLaborales,
  crearCategoriaLaboral,
  actualizarCategoriaLaboral,
  eliminarCategoriaLaboral,
} from '../../../../shared/services/api';
import { AdminCatalogoSimple } from './AdminCatalogoSimple';

export function AdminCategoriasLaborales() {
  const { t } = useI18n();
  const labels = t.structure.admin.categoriasLaborales;
  return (
    <AdminCatalogoSimple
      labels={labels}
      api={{
        list: () => fetchCategoriasLaborales(true),
        create: crearCategoriaLaboral,
        update: actualizarCategoriaLaboral,
        remove: eliminarCategoriaLaboral,
      }}
    />
  );
}
